import { defineComponent as o, createElementBlock as t, openBlock as n, normalizeProps as l, guardReactiveProps as d, unref as f, renderSlot as i } from "vue";
import { useBindCx as a } from "@scalar/components";
const u = /* @__PURE__ */ o({
  __name: "ViewLayout",
  setup(m) {
    const { cx: e } = a();
    return (r, s) => (n(), t("div", l(d(
      f(e)(
        "flex flex-col min-h-0 flex-1 *:border-t first:*:border-t-0 md:*:border-t-0 xl:overflow-hidden md:flex-row leading-3"
      )
    )), [
      i(r.$slots, "default")
    ], 16));
  }
});
export {
  u as default
};
